import BarChartOutlined from '@material-ui/icons/BarChartOutlined'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import messages from '../../../../assets/messages'
import {PammOfferType} from '../../../../graphql/types'
import {kpiPanelId, useKpiPanel} from '../KpiPanelContext'
import {KpiButton} from './OfferCardActions.styled'

type KpiToggleButtonProps = {
  offer: PammOfferType
} & WithNamespaces

/**
 * The "KPIs" button on an offer card (PT-5710). Toggling opens the node's inline KPI panel and
 * closes any other node's panel, via the shared {@link useKpiPanel} state. The button mirrors the
 * panel state through `aria-expanded` and a pressed (`active`) style so it is legible to both
 * assistive tech and sighted users.
 *
 * @param offer - The PAMM offer this button belongs to; its id keys the shared open state.
 * @param t - Translation function injected by `withNamespaces`, used for the aria-label.
 */
const _KpiToggleButton = ({offer, t}: KpiToggleButtonProps) => {
  const {isOpen, toggle} = useKpiPanel()
  const nodeId = String(offer.id)
  const open = isOpen(nodeId)

  return (
    <KpiButton
      type="button"
      variant="outlined"
      size="small"
      data-active={open}
      aria-expanded={open}
      aria-controls={kpiPanelId(nodeId)}
      aria-label={t(messages.pammKpiToggleAria.i18nKey, messages.pammKpiToggleAria.defaults)}
      startIcon={<BarChartOutlined />}
      onClick={() => toggle(nodeId)}
    >
      <Trans {...messages.pammKpiToggle} />
    </KpiButton>
  )
}

export const KpiToggleButton = withNamespaces()(_KpiToggleButton)
